import PropTypes from 'prop-types';

const ProductShape = PropTypes.shape({
  shopifyId: PropTypes.string,
  title: PropTypes.string,
  handle: PropTypes.string,
  description: PropTypes.string,
  availableForSale: PropTypes.bool,
  vendor: PropTypes.string,
  productType: PropTypes.string,
  priceRangeV2: PropTypes.shape({
    minVariantPrice: PropTypes.shape({
      amount: PropTypes.number.isRequired,
    }),
    maxVariantPrice: PropTypes.shape({
      amount: PropTypes.number.isRequired,
    }),
  }),
  media: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.shape({
        src: PropTypes.string,
      }),
    })
  ),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      values: PropTypes.arrayOf(PropTypes.string),
    })
  ),
  variants: PropTypes.arrayOf(
    PropTypes.shape({
      shopifyId: PropTypes.string,
      availableForSale: PropTypes.bool,
      sku: PropTypes.string,
      image: PropTypes.shape({ id: PropTypes.string }),
      price: PropTypes.number,
      compareAtPrice: PropTypes.number,
      selectedOptions: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          value: PropTypes.string,
        })
      ),
    })
  ),
  searchedProduct: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string),
});
export default ProductShape;
